import { all, call, put, fork } from 'redux-saga/effects'
import { get } from 'lodash-es'
import { exportSagas } from '../shared/utils/sagas'
import { sentryConfigureGlobalScope } from '../shared/utils'
import { actionNames } from './actions'
import { loadSiteData, getUser } from './api'
import { watchRefetchSiteData } from './sagas.shared'

const configureSentryGlobalScopeWorker = (siteData, userData) => {
  const productKey = get(siteData, 'site.product_key')
  const productGrade = get(siteData, 'site.product_grade')
  const siteUrl = get(siteData, 'site.site_url')
  const userName = get(userData, 'user.display_name')
  const userId = get(userData, 'user.user_id')

  const configureScope = (scope) => {
    scope.setTag('product', productKey)
    scope.setTag('grade', productGrade)
    scope.setExtra('url', siteUrl)
    scope.setUser({ id: userId, name: userName })
  }

  sentryConfigureGlobalScope(configureScope)
}

function* init() {
  // we do fetch the user in the personal sagas
  // once we merge the two file sagas together we will have a single place
  // from where we can fetch and update user details

  // for now we just want to make sure that we can load the user, a.k.a he/she is logged in
  try {
    const { data, user } = yield all({
      data: call(loadSiteData, { include_quota_p: 1 }),
      user: call(getUser),
    })
    yield put({ type: actionNames.INIT_APP_SUCCESS, data })
    configureSentryGlobalScopeWorker(data, user)
  } catch (err) {
    // yes, keep it logout here
    window.location.replace('/logout')
  }
}

function* sagasShared() {
  yield fork(watchRefetchSiteData)
}

export default exportSagas(
  [init, sagasShared],
  actionNames.INIT_APP,
  actionNames.LEAVE_APP
)

export { init }
